// src/pages/laboratory/Dashboard.jsx - Updated with routing and new dashboard
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import your laboratory pages
import MainDashboard from './MainDashboard'; // The new dashboard component we just created
import PromotionsPage from './Promotions';
import ProductsPage from './Products';
import MessagesPage from './Messages';
import TransactionsPage from './Transactions';
import ContractsPage from './Contracts';
import LaboratoryNotifications from './Notifications'; // New import


const LaboratoryDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Main Dashboard - the new component */}
        <Route path="/" element={<Navigate to="/laboratory/dashboard" replace />} />
        <Route path="/dashboard" element={<MainDashboard />} />

        {/* Products management */}
        <Route path="/products" element={<ProductsPage />} />

        {/* Promotions management */}
        <Route path="/promotions" element={<PromotionsPage />} />

        {/* Messages with admin */}
        <Route path="/messages" element={<MessagesPage />} />

        {/* Transactions overview */}
        <Route path="/transactions" element={<TransactionsPage />} />

        {/* Contracts overview */}
        <Route path="/contracts" element={<ContractsPage />} />

        {/* Notifications overview */}
        <Route path="/Notifications" element={<LaboratoryNotifications />} />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/laboratory/dashboard" replace />} />
      </Routes>
    </div>
  );
};

export default LaboratoryDashboard;